/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [PC质检↗](http://yapi.yishou.com/project/128/interface/api/30374) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `高级质检`
 * @请求头 `POST /erp/QualityChecking/pcCheck`
 */
const pcCheckRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/pcCheck",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["dbid", "cp_code", "desk_no", "is_pc", "high_quality", "is_remarking"],
        properties: {
            dbid: { type: "string", description: "打标ID" },
            cp_code: { type: "string", description: "扫描次品类型或提交码， 非次品为空提交" },
            desk_no: { type: "string", description: "工作台" },
            is_pc: { type: "string", description: "" },
            high_quality: {
                type: "string",
                description: "是否高级质检通过 1 通过  2 未通过（当cp_code 为空提交时，这个字段才有作用）",
            },
            is_remarking: { type: "string", description: "是否重新更换袋子(重新打标)：0 否 1是" },
            is_cp_pop_up: { type: "string", description: "是否次品弹窗{1:是;2:否}  弹窗传参的时候才需要传 1" },
            the_level: {
                type: "string",
                description: "次品等级 {1:轻微瑕疵品;2:中度瑕疵品;3:严重瑕疵品;4:极度次品;}  次品弹窗 为 1 时必传",
            },
            problem_type: {
                type: "string",
                description: "问题分类{1:表面脏损;2:零配缺失;3:针线不良;4:工艺变色;5:面料变色;6:面料不良;7:错款;8:改标次品;}    次品弹窗 为 1 时必传",
            },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            print_data: {
                type: "object",
                properties: {
                    cmd: { type: "string" },
                    requestID: { type: "number" },
                    version: { type: "string" },
                    task: {
                        type: "object",
                        properties: {
                            taskID: { type: "string" },
                            preview: { type: "boolean" },
                            previewType: { type: "string" },
                            firstDocumentNumber: { type: "number" },
                            totalDocumentCount: { type: "number" },
                            documents: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        documentID: { type: "string" },
                                        contents: {
                                            type: "array",
                                            items: {
                                                type: "object",
                                                properties: {
                                                    data: {
                                                        type: "object",
                                                        properties: {
                                                            goods_name: { type: "string" },
                                                            dbid: { type: "string" },
                                                            sku: { type: "string" },
                                                            tag1: { type: "string" },
                                                            tag2: { type: "string" },
                                                            space: { type: "string" },
                                                            goods_no: { type: "string" },
                                                            sku_id: { type: "string" },
                                                            qr_code: { type: "string" },
                                                            pgname: { type: "string" },
                                                            sort_no: { type: "string" },
                                                            img_url: { type: "string" },
                                                            co_val: { type: "string" },
                                                            si_val: { type: "string" },
                                                            parts_img: { type: "string" },
                                                            suit_img: { type: "string" },
                                                            intercept_img: { type: "string" },
                                                            hg_group: { type: "string" },
                                                            goods_kh: { type: "string" },
                                                            mark: { type: "string" },
                                                        },
                                                    },
                                                    templateURL: { type: "string" },
                                                },
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
    requestFunctionName: "pcCheck",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [PC质检↗](http://yapi.yishou.com/project/128/interface/api/30374) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `高级质检`
 * @请求头 `POST /erp/QualityChecking/pcCheck`
 */
export const pcCheck = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(pcCheckRequestConfig, requestData), ...args);
};
pcCheck.requestConfig = pcCheckRequestConfig;
/**
 * 接口 [质检商品数据↗](http://yapi.yishou.com/project/128/interface/api/30378) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/QualityChecking/getGoodsInfoForPcQc`
 */
const getGoodsInfoForPcQcRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/getGoodsInfoForPcQc",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["dbid", "is_pc"],
        properties: {
            dbid: { type: "string", description: "打标ID" },
            is_pc: { type: "string", description: "" },
            is_repeat: { type: "string", description: "是否重复质检  0 否 1 是 ， 默认为  0 " },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            color_card: {
                type: "array",
                items: {
                    type: "object",
                    properties: { thumb: { type: "string" }, co_val: { type: "string" } },
                    required: ["thumb", "co_val"],
                },
            },
            imgs: { type: "array", items: { type: "string" } },
            goods_info: {
                type: "object",
                properties: {
                    goods_name: { type: "string" },
                    goods_no: { type: "string" },
                    co_val: { type: "string" },
                    si_val: { type: "string" },
                    si_id: { type: "string" },
                    co_id: { type: "string" },
                    supply_id: { type: "string" },
                    supply_name: { type: "string" },
                    type: { type: "string" },
                    parts: { type: "string" },
                    cat_name: { type: "string" },
                    thumb: { type: "string", description: "色卡图" },
                },
                required: ["thumb"],
            },
            qc_info_history: { type: "array", items: { type: "string" } },
            today: { type: "object", properties: { total: { type: "number" }, cp: { type: "number" } } },
            storage_report: { type: "array", items: { type: "string" } },
            so_history: { type: "array", items: { type: "string" } },
            wave_pick_check: {
                type: "object",
                properties: {
                    quality: {
                        type: "object",
                        properties: {
                            "0": { type: "string" },
                            "1": { type: "string" },
                            "2": { type: "string" },
                            "4": { type: "string" },
                            "5": { type: "string" },
                        },
                    },
                    problem_desc: { type: "string" },
                    service_desc: { type: "string" },
                    blp_note: { type: "string" },
                    picture: { type: "array", items: { type: "string" } },
                    is_zj_as_wp: { type: "number" },
                    pickingWorkPicture: { type: "array", items: { type: "string" } },
                    pickingOtherPicture: { type: "array", items: { type: "string" } },
                    problem: { type: "array", items: { type: "string" }, description: "质量问题" },
                    cat: { type: "array", items: { type: "string" }, description: "品类问题" },
                },
                required: ["problem", "cat"],
            },
            order_high_quality: { type: "array", items: { type: "string" } },
            is_high_quality: { type: "number" },
            is_gb_user_white: { type: "number", description: "是否改标白名单用户 1 是 0 否" },
            is_keep_tag: { type: "number", description: "是否留标：1是，0否", tag: "#3082改标库存管理" },
            cp_category: {
                type: "object",
                properties: {
                    name: { type: "string", description: "类型名称" },
                    code: { type: "string", description: "类型code码" },
                },
                description: "质检次品类型",
                required: ["name", "code"],
            },
            is_return_goods: { type: "string", description: "二次退换标识  1是 0 否" },
            service_order_imgs: { type: "array", items: { type: "string" }, description: "工单图片" },
        },
        required: ["is_gb_user_white", "is_keep_tag", "cp_category", "is_return_goods", "service_order_imgs"],
    },
    requestFunctionName: "getGoodsInfoForPcQc",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [质检商品数据↗](http://yapi.yishou.com/project/128/interface/api/30378) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/QualityChecking/getGoodsInfoForPcQc`
 */
export const getGoodsInfoForPcQc = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getGoodsInfoForPcQcRequestConfig, requestData), ...args);
};
getGoodsInfoForPcQc.requestConfig = getGoodsInfoForPcQcRequestConfig;
/**
 * 接口 [质检列表↗](http://yapi.yishou.com/project/128/interface/api/30382) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `高级质检`, `新增质检规则`
 * @请求头 `POST /erp/QualityChecking/getList`
 */
const getListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/getList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["order_id", "quality_rule", "is_minor_defect"],
        properties: {
            high_quality: { type: "string", description: "是否高级质检 1 是  2 不是" },
            order_id: { type: "string", description: "订单编号" },
            quality_rule: {
                type: "string",
                description: "质检规则{1:默认质检规则配置,2:质检绿色通道配置,3:高级质检商品配置,4:二次重配商品配置,5:高价值商品配置,6:高排单/区域订单商品配置,7:新客订单质检配置,8:高净值用户质检配置}",
            },
            is_minor_defect: { type: "string", description: "是否微次{1:是;2:否}" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            count: { type: "number" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        qc_id: { type: "string" },
                        dbid: { type: "string" },
                        sdbrid: { type: "null" },
                        create_time: { type: "string" },
                        remark: { type: "string" },
                        qc: { type: "string" },
                        desk_no: { type: "string" },
                        quality_checking_is_cp: { type: "string" },
                        quality_checking_is_repair: { type: "string" },
                        cp_name: { type: "null" },
                        p_name: { type: "null" },
                        goods_name: { type: "string" },
                        market_name: { type: "string" },
                        brand_name: { type: "string" },
                        goods_no: { type: "string" },
                        co_val: { type: "string" },
                        si_val: { type: "string" },
                        pg_name: { type: "string" },
                        supply_name: { type: "string" },
                        sku: { type: "string" },
                        quality_type: { type: "string" },
                        is_pc_check: { type: "string" },
                        xf_qc: { type: "string" },
                        xf_time: { type: "null" },
                        pc_checker: { type: "string" },
                        dber: { type: "string" },
                        cat_name_3: { type: "string" },
                        cat_name_2: { type: "string" },
                        cat_name_1: { type: "string" },
                        stockin_time: { type: "string" },
                        stock_in_record_type: { type: "string" },
                        stock_in_record_stock_source: { type: "string" },
                        stock_out_type: { type: "null" },
                        sdbr_text: { type: "string" },
                        is_shipping_stock_out: { type: "string" },
                        high_quality: { type: "string", description: "是否高级质检" },
                        high_quality_text: { type: "string", description: "是否高级质检" },
                        quality_rule: {
                            type: "string",
                            description: "质检规则{1:默认质检规则配置,2:质检绿色通道配置,3:高级质检商品配置,4:二次重配商品配置,5:高价值商品配置,6:高排单/区域订单商品配置,7:新客订单质检配置,8:高净值用户质检配置}",
                            tag: "新增质检规则",
                        },
                        order_id: { type: "string", description: "订单编号", tag: "新增质检规则" },
                        is_minor_defect_text: { type: "string", description: "是否微次" },
                    },
                    required: ["quality_rule", "order_id", "is_minor_defect_text"],
                },
            },
            condition: {
                type: "object",
                properties: {
                    cat: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: { cat_id: { type: "string" }, cat_name: { type: "string" } },
                            required: ["cat_id", "cat_name"],
                        },
                    },
                    market: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: { market_id: { type: "string" }, market_name: { type: "string" } },
                            required: ["market_id", "market_name"],
                        },
                    },
                    picker_group: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: { pg_id: { type: "string" }, pg_name: { type: "string" } },
                            required: ["pg_id", "pg_name"],
                        },
                    },
                    cp_cat: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: { cp_catid: { type: "string" }, name: { type: "string" }, pid: { type: "string" } },
                            required: ["cp_catid", "name", "pid"],
                        },
                    },
                    stockSource: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: { key: { type: "number" }, label: { type: "string" } },
                            required: ["key", "label"],
                        },
                    },
                    quality_rule: {
                        type: "array",
                        items: {
                            type: "object",
                            properties: { key: { type: "string" }, label: { type: "string" } },
                            required: ["key", "label"],
                        },
                        tag: "新增质检规则",
                    },
                },
                required: ["quality_rule"],
            },
            origin: { type: "number" },
        },
    },
    requestFunctionName: "getList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [质检列表↗](http://yapi.yishou.com/project/128/interface/api/30382) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `高级质检`, `新增质检规则`
 * @请求头 `POST /erp/QualityChecking/getList`
 */
export const getList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getListRequestConfig, requestData), ...args);
};
getList.requestConfig = getListRequestConfig;
/**
 * 接口 [改标列表↗](http://yapi.yishou.com/project/128/interface/api/30390) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `高级质检`
 * @请求头 `POST /erp/GaiBiao/getGbInputRecordList`
 */
const getGbInputRecordListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/getGbInputRecordList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["goods_type"],
        properties: {
            high_quality: { type: "string", description: "是否高级质检 1 是  2 不是" },
            goods_type: { type: "string", description: "改标录入商品类型{" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        dbid: { type: "string" },
                        gb_type_id: { type: "number", description: "改标类型id（新增用于回选）" },
                        goods_name: { type: "string" },
                        sku: { type: "string" },
                        goods_no: { type: "string" },
                        co_val: { type: "string" },
                        si_val: { type: "string" },
                        third_cat: { type: "string" },
                        second_cat: { type: "string" },
                        first_cat: { type: "string" },
                        market_name: { type: "string" },
                        brand_name: { type: "string" },
                        supply_name: { type: "string" },
                        stock_in_time: { type: "string" },
                        gb_input_time: { type: "string" },
                        gb_user_name: { type: "string" },
                        gb_type_name: { type: "string" },
                        wave_picking_no: { type: "string" },
                        user_id: { type: "string" },
                        is_stock_out: { type: "string" },
                        high_quality: { type: "string", description: "是否高级质检" },
                        high_quality_text: { type: "string", description: "是否高级质检" },
                        goods_type: { type: "string", description: "商品类型字符串" },
                    },
                    required: ["gb_type_id", "goods_type"],
                },
            },
            gb_type_list: {
                type: "array",
                items: {
                    type: "object",
                    properties: { id: { type: "string" }, name: { type: "string" } },
                    required: ["id", "name"],
                },
            },
            count: { type: "number" },
            page: { type: "number" },
            pagesize: { type: "number" },
        },
    },
    requestFunctionName: "getGbInputRecordList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [改标列表↗](http://yapi.yishou.com/project/128/interface/api/30390) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `高级质检`
 * @请求头 `POST /erp/GaiBiao/getGbInputRecordList`
 */
export const getGbInputRecordList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getGbInputRecordListRequestConfig, requestData), ...args);
};
getGbInputRecordList.requestConfig = getGbInputRecordListRequestConfig;
/**
 * 接口 [获取商品历史信息↗](http://yapi.yishou.com/project/128/interface/api/34152) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/TakeStock/getQcGoodsHistoryInfo`
 */
const getQcGoodsHistoryInfoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/TakeStock/getQcGoodsHistoryInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["sku"],
        properties: { sku: { type: "string", description: "sku" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            goodsInfo: {
                type: "object",
                properties: {
                    goods_name: { type: "string", description: '"【红唇】连衣裙  98985958146#  qyz"' },
                    goods_no: { type: "string", description: '"1153200004"' },
                    supply_id: { type: "string", description: '"135"' },
                    parts: { type: "string", description: '"无"' },
                    co_val: { type: "string", description: '"黑色"' },
                    si_val: { type: "string", description: '"M"' },
                    si_id: { type: "string", description: '"1"' },
                    co_id: { type: "string", description: '"1017"' },
                    supply_name: { type: "string", description: '"5-31A-红唇"' },
                    cat_name: { type: "string", description: '"连衣裙"' },
                    type: { type: "string", description: '"代采欠货"' },
                },
                additionalProperties: false,
            },
            soHistory: {
                type: "array",
                items: { type: "string", description: '"掉扣子"' },
                description: '["掉扣子","缩水","掉毛","掉皮"]',
            },
            storageReport: {
                type: "array",
                items: { type: "string", description: '"内外标码不一致"' },
                description: '["内外标码不一致"]',
            },
            qcInfoHistory: {
                type: "array",
                items: { type: "string", description: '"起毛/起球"' },
                description: '["起毛/起球"]',
            },
            today: {
                type: "object",
                properties: { total: { type: "integer", description: "1" }, cp: { type: "integer", description: "1" } },
                additionalProperties: false,
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getQcGoodsHistoryInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取商品历史信息↗](http://yapi.yishou.com/project/128/interface/api/34152) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/TakeStock/getQcGoodsHistoryInfo`
 */
export const getQcGoodsHistoryInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getQcGoodsHistoryInfoRequestConfig, requestData), ...args);
};
getQcGoodsHistoryInfo.requestConfig = getQcGoodsHistoryInfoRequestConfig;
/**
 * 接口 [获取质检map↗](http://yapi.yishou.com/project/128/interface/api/34186) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/TakeStock/getQcCheckMap`
 */
const getQcCheckMapRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/TakeStock/getQcCheckMap",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "object",
                properties: {
                    ZJ19: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"1"' },
                            formal: { type: "string", description: '"错色"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ20: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"2"' },
                            formal: { type: "string", description: '"错码"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ25: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"3"' },
                            formal: { type: "string", description: '"缺配件"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ01: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"起毛/起球"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ02: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"勾丝"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ03: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"掉扣子"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ04: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"破洞"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ05: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"面料不平整"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ06: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"开线落线"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ07: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"拉链问题"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ08: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"配饰问题"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ09: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"车线不好"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ10: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"版型问题"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ11: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"污渍"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ12: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"染色"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ13: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"杂线"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ14: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"掉皮"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ15: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"掉毛"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ16: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"有异味"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ17: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"掉色"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ18: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"缩水"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ23: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"领标不一致"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ24: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"脱胶"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ26: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"面料划损"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ21: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"错款"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ22: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"4"' },
                            formal: { type: "string", description: '"其他"' },
                        },
                        additionalProperties: false,
                    },
                    ZJ27: {
                        type: "object",
                        properties: {
                            blpTypeKey: { type: "string", description: '"11"' },
                            formal: { type: "string", description: '"套装不齐"' },
                        },
                        additionalProperties: false,
                    },
                },
                additionalProperties: false,
            },
            blpType: {
                type: "array",
                items: { type: "string" },
                description: '["","错色","错码","少配件","次品","错款","核销","差异","退还","次品(可换)","色差","套装不全","售后退供"]',
            },
            isShowQc: { type: "integer", description: "1" },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getQcCheckMap",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取质检map↗](http://yapi.yishou.com/project/128/interface/api/34186) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/TakeStock/getQcCheckMap`
 */
export const getQcCheckMap = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getQcCheckMapRequestConfig, requestData), ...args);
};
getQcCheckMap.requestConfig = getQcCheckMapRequestConfig;
/**
 * 接口 [获取来货质检点货配置↗](http://yapi.yishou.com/project/128/interface/api/35770) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `来货质检`
 * @请求头 `POST /erp/AdminSetting/getDaBiaoIntercept`
 */
const getDaBiaoInterceptRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/getDaBiaoIntercept",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            customer_intercept_defective: { type: "string", description: "只拦截客服的疑似次品商品进行质检{1:开启，2:关闭}" },
            storehouse_intercept_defective: {
                type: "string",
                description: "只拦截仓库质检次品率高的商品进行质检{1:开启，2:关闭}",
            },
        },
    },
    requestFunctionName: "getDaBiaoIntercept",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取来货质检点货配置↗](http://yapi.yishou.com/project/128/interface/api/35770) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `来货质检`
 * @请求头 `POST /erp/AdminSetting/getDaBiaoIntercept`
 */
export const getDaBiaoIntercept = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getDaBiaoInterceptRequestConfig, requestData), ...args);
};
getDaBiaoIntercept.requestConfig = getDaBiaoInterceptRequestConfig;
/**
 * 接口 [保存来货质检配置↗](http://yapi.yishou.com/project/128/interface/api/35779) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `来货质检`
 * @请求头 `POST /erp/AdminSetting/setDaBiaoIntercept`
 */
const setDaBiaoInterceptRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/AdminSetting/setDaBiaoIntercept",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["customer_intercept_defective", "storehouse_intercept_defective"],
        properties: {
            customer_intercept_defective: { type: "string" },
            storehouse_intercept_defective: { type: "string", description: "" },
        },
    },
    responseDataJsonSchema: { type: "string" },
    requestFunctionName: "setDaBiaoIntercept",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [保存来货质检配置↗](http://yapi.yishou.com/project/128/interface/api/35779) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @标签 `来货质检`
 * @请求头 `POST /erp/AdminSetting/setDaBiaoIntercept`
 */
export const setDaBiaoIntercept = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setDaBiaoInterceptRequestConfig, requestData), ...args);
};
setDaBiaoIntercept.requestConfig = setDaBiaoInterceptRequestConfig;
/**
 * 接口 [dbid绑定安全扣↗](http://yapi.yishou.com/project/128/interface/api/35806) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/QualityChecking/bindSafeLock`
 */
const bindSafeLockRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/bindSafeLock",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["dbid", "safe_lock"],
        properties: {
            dbid: { type: "string", description: "打标ID" },
            safe_lock: { type: "string", description: "安全扣ID（最多15个字符）" },
        },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "bindSafeLock",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [dbid绑定安全扣↗](http://yapi.yishou.com/project/128/interface/api/35806) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/QualityChecking/bindSafeLock`
 */
export const bindSafeLock = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(bindSafeLockRequestConfig, requestData), ...args);
};
bindSafeLock.requestConfig = bindSafeLockRequestConfig;
/**
 * 接口 [绑定容器并且绑定工作台↗](http://yapi.yishou.com/project/128/interface/api/35815) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/QualityChecking/bindBox`
 */
const bindBoxRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/bindBox",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["box_no", "desk_no", "box_type"],
        properties: {
            box_no: { type: "string", description: "容器编号" },
            desk_no: { type: "string", description: "工作台" },
            box_type: { type: "string", description: "容器类型{normal：正常，stock：库存分离}" },
        },
    },
    responseDataJsonSchema: { type: "array", items: { type: "string" } },
    requestFunctionName: "bindBox",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [绑定容器并且绑定工作台↗](http://yapi.yishou.com/project/128/interface/api/35815) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/QualityChecking/bindBox`
 */
export const bindBox = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(bindBoxRequestConfig, requestData), ...args);
};
bindBox.requestConfig = bindBoxRequestConfig;
/**
 * 接口 [获取绑定信息↗](http://yapi.yishou.com/project/128/interface/api/35824) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/QualityChecking/getBindInfo`
 */
const getBindInfoRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/getBindInfo",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            desk_no: { type: "string", description: "工作台" },
            normal_box: { type: "number", description: "正常容器ID" },
            normal_box_no: { type: "string", description: "正常容器号" },
            stock_box: { type: "number", description: "越库容器ID" },
            stock_box_no: { type: "string", description: "越库容器号" },
        },
    },
    requestFunctionName: "getBindInfo",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取绑定信息↗](http://yapi.yishou.com/project/128/interface/api/35824) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/QualityChecking/getBindInfo`
 */
export const getBindInfo = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getBindInfoRequestConfig, requestData), ...args);
};
getBindInfo.requestConfig = getBindInfoRequestConfig;
/**
 * 接口 [关闭容器↗](http://yapi.yishou.com/project/128/interface/api/35833) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/QualityChecking/closeBox`
 */
const closeBoxRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/QualityChecking/closeBox",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["desk_no", "box_type"],
        properties: {
            desk_no: { type: "string", description: "工作台" },
            box_type: { type: "string", description: "容器类型{normal：正常，stock：库存分离}" },
        },
    },
    responseDataJsonSchema: { type: "object", title: "empty object", properties: {} },
    requestFunctionName: "closeBox",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [关闭容器↗](http://yapi.yishou.com/project/128/interface/api/35833) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/QualityChecking/closeBox`
 */
export const closeBox = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(closeBoxRequestConfig, requestData), ...args);
};
closeBox.requestConfig = closeBoxRequestConfig;
/**
 * 接口 [获取改标录入-商品类型枚举↗](http://yapi.yishou.com/project/128/interface/api/38679) 的 **请求配置**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/GaiBiao/getGaiBiaoGoodsTypeEnum`
 */
const getGaiBiaoGoodsTypeEnumRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/getGaiBiaoGoodsTypeEnum",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            da_biao_goods_type_enum: {
                type: "array",
                items: {
                    type: "object",
                    properties: { value: { type: ["string", "number"] }, label: { type: "string" } },
                    required: ["value", "label"],
                },
                description: "改标录入-商品类型枚举",
            },
        },
    },
    requestFunctionName: "getGaiBiaoGoodsTypeEnum",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取改标录入-商品类型枚举↗](http://yapi.yishou.com/project/128/interface/api/38679) 的 **请求函数**
 *
 * @分类 [质检改标↗](http://yapi.yishou.com/project/128/interface/api/cat_2353)
 * @请求头 `POST /erp/GaiBiao/getGaiBiaoGoodsTypeEnum`
 */
export const getGaiBiaoGoodsTypeEnum = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getGaiBiaoGoodsTypeEnumRequestConfig, requestData), ...args);
};
getGaiBiaoGoodsTypeEnum.requestConfig = getGaiBiaoGoodsTypeEnumRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/quality2353.js